import React from "react";
import useSolutionsLogic from "./hooks/useSolutionsLogic";
import SolutionsDesktop from "./components/SolutionsDesktop";
import SolutionsMobile from "./components/SolutionsMobile";

function Solutions() {
  const { screenSize } = useSolutionsLogic();

  if (screenSize === "mobile") return <SolutionsMobile />;
  return <SolutionsDesktop />;
}

export default Solutions;
